module.exports = __webpack_public_path__ + "static/media/11.650aab66.png";